// extracted by mini-css-extract-plugin
module.exports = {"link":"PlatformButton-module--link--2DzxK"};